// Rad Tech Foundry - Latest Electronics, Smart Gadgets & Tech Innovations

// ============================================
// SITE IMAGES
// ============================================
export const siteImages = {
  heroMain: 'https://images.unsplash.com/photo-1601950214268-d063b21f586b?q=80&w=2670&auto=format&fit=crop',
  heroSecondary: 'https://images.unsplash.com/photo-1615743879132-3244ab6efcd1?q=80&w=2670&auto=format&fit=crop',
  heroLifestyle: 'https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=2670&auto=format&fit=crop',
  ctaBackground: 'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?q=80&w=2670&auto=format&fit=crop',
  featuredBackground: 'https://images.unsplash.com/photo-1593305841991-05c297ba4575?q=80&w=2670&auto=format&fit=crop',
  powerBackground: 'https://novagen.s3.us-east-2.amazonaws.com/vI2q4IFJf81VmvHKWJuEjGRHJbyitaFGg0icOElG.jpg',
  shopBanner: 'https://images.unsplash.com/photo-1550009158-9ebf69173e03?q=80&w=2670&auto=format&fit=crop',
  aboutBanner: 'https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=2670&auto=format&fit=crop',
  contactBanner: 'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?q=80&w=2670&auto=format&fit=crop',
  returnsBanner: 'https://images.unsplash.com/photo-1531297484001-80022131f5a1?q=80&w=2670&auto=format&fit=crop',
  privacyBanner: 'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?q=80&w=2670&auto=format&fit=crop',
};

export const SHIPPING_NOTICE = 'We ship within the USA via USPS';
export const SHIPPING_COUNTRIES = ['US'];
export const SHIPPING_METHOD = 'USPS';
export const SHIPPING_TIME = '2-4 business days';
export const FREE_SHIPPING_THRESHOLD = 75;

export const CARD_DESCRIPTOR = 'RAD TECH FOUNDRY';
export const HOSTING_PROVIDER = 'Hostinger';

export const CONTACT_INFO = {
  phone: '(833) 476-5857',
  email: 'contactus@radtechfoundry.com',
  corpName: 'Radan Capital Management LLC',
  domain: 'radtechfoundry.com',
  address: {
    street: '547 E Altgeld Ave',
    city: 'Glendale Heights',
    state: 'IL',
    zip: '60139',
    country: 'United States'
  }
};

// NOTE: Return address intentionally left unchanged
export const RETURN_ADDRESS = {
  street: '4711 34th St. N. Suite F',
  city: 'St. Petersburg',
  state: 'FL',
  zip: '33714',
  country: 'USA'
};

// ============================================
// PRODUCTS — Tech & Electronics
// Prices restricted to the approved set only:
// 8.99, 11.49, 17.49, 17.98, 26.97, 34.98, 35.96, 52.47, 69.96, 120.08, 213.32, 239.94
// ============================================
export const products = [
  // ---------- SPEAKERS & AUDIO ----------
  {
    id: 'bluetooth-computer-speaker-system',
    name: 'Bluetooth Computer Speaker System',
    slug: 'bluetooth-computer-speaker-system',
    sku: 'RTF-SPK-001',
    price: 17.49,
    image: 'https://novagen.s3.us-east-2.amazonaws.com/01J0BNBP8EJV7FBNMHNWBEKY2T.jpg',
    badge: 'Deal',
    categoryId: 'speakers',
    categorySlug: 'speakers',
    description: 'A futuristic desktop speaker system that upgrades your computer audio with rich, room-filling stereo sound and a compact, glow-accented design.',
    keyBenefits: ['Crisp, balanced stereo sound', 'Wireless Bluetooth + wired AUX', 'Compact footprint for any desk'],
    usage: 'Pair via Bluetooth or connect the 3.5mm AUX cable, set on your desk, and adjust volume with the inline dial.',
    features: ['Bluetooth 5.0', 'AUX Input', 'USB Powered', 'Stereo Sound'],
    inStock: true,
  },
  {
    id: 'smart-bluetooth-speaker-led',
    name: 'Smart Bluetooth Speaker with Color-Changing LED',
    slug: 'smart-bluetooth-speaker-led',
    sku: 'RTF-SPK-002',
    price: 26.97,
    image: 'https://novagen.s3.us-east-2.amazonaws.com/01J09AS7CC0YW1C0Q7DZD6HAWH.jpg',
    badge: 'Bestseller',
    categoryId: 'speakers',
    categorySlug: 'speakers',
    description: 'A fusion of sound and light, this portable Bluetooth speaker pumps out bold audio while cycling through vibrant color-changing LED moods.',
    keyBenefits: ['Dynamic color-changing LED light show', 'Punchy bass in a portable shell', 'Hands-free calls with built-in mic'],
    usage: 'Power on, pair over Bluetooth, and tap the light button to cycle through LED modes while you play your favorite tracks.',
    features: ['RGB LED', 'Bluetooth 5.0', 'Built-in Mic', 'Rechargeable'],
    inStock: true,
  },
  {
    id: 'hd-soundbar-with-subwoofer',
    name: 'HD Soundbar with Wireless Subwoofer',
    slug: 'hd-soundbar-with-subwoofer',
    sku: 'RTF-SPK-003',
    price: 120.08,
    image: 'https://novagen.s3.us-east-2.amazonaws.com/2AcnDnCC0TEDlNuC0lIzKzZmiQwN58TqS5c1EG4p.png',
    badge: 'Premium',
    categoryId: 'speakers',
    categorySlug: 'speakers',
    description: 'A compact 2.1-channel HD soundbar paired with a wireless subwoofer delivering deep, cinematic bass and clear dialogue for movies, music and games.',
    keyBenefits: ['120W of cinematic 2.1 sound', 'Wireless subwoofer for deep bass', 'HDMI ARC, optical and Bluetooth inputs'],
    usage: 'Place the bar below your TV, position the subwoofer nearby, connect via HDMI ARC or Bluetooth, and select your sound mode.',
    features: ['2.1 Channel', '120W Output', 'Wireless Sub', 'HDMI ARC'],
    inStock: true,
  },
  {
    id: 'portable-bluetooth-speaker',
    name: 'Rugged Portable Bluetooth Speaker',
    slug: 'portable-bluetooth-speaker',
    sku: 'RTF-SPK-004',
    price: 69.96,
    image: 'https://novagen.s3.us-east-2.amazonaws.com/01HZMJWMG01Y7KWEEAZ8VBAEPC.jpg',
    categoryId: 'speakers',
    categorySlug: 'speakers',
    description: 'Unleash powerful, dynamic sound wherever you go with this robust portable Bluetooth speaker built for adventures, parties and everyday listening.',
    keyBenefits: ['Loud, well-rounded outdoor sound', 'All-day rechargeable battery', 'Splash-resistant durable build'],
    usage: 'Charge fully, pair with your phone over Bluetooth, and take it anywhere — beach, backyard or backpack.',
    features: ['Splash Resistant', 'Long Battery', 'Bluetooth 5.0', 'Portable'],
    inStock: true,
  },

  // ---------- HEADPHONES & EARBUDS ----------
  {
    id: 'touch-control-true-wireless-earbuds',
    name: 'Touch-Control True Wireless Earbuds',
    slug: 'touch-control-true-wireless-earbuds',
    sku: 'RTF-AUD-005',
    price: 34.98,
    image: 'https://novagen.s3.us-east-2.amazonaws.com/01HZMJD2REDNBBJFD28P8BP3YE.jpg',
    categoryId: 'headphones',
    categorySlug: 'headphones',
    description: 'Step into a world of crystal-clear sound with these compact touch-control true wireless earbuds and their pocketable charging case.',
    keyBenefits: ['Intuitive touch controls', 'Compact charging case', 'Secure, comfortable fit'],
    usage: 'Remove from the case to auto-pair, tap the earbuds to play, pause or take calls, and recharge in the case between uses.',
    features: ['True Wireless', 'Touch Control', 'Charging Case', 'Built-in Mic'],
    inStock: true,
  },
  {
    id: 'active-noise-cancelling-earbuds-pro',
    name: 'Active Noise-Cancelling Earbuds Pro',
    slug: 'active-noise-cancelling-earbuds-pro',
    sku: 'RTF-AUD-006',
    price: 69.96,
    image: 'https://novagen.s3.us-east-2.amazonaws.com/sYSRnrMgToy1mcA5rewreSId2TR07vDUclS9LATv.png',
    badge: 'Bestseller',
    categoryId: 'headphones',
    categorySlug: 'headphones',
    description: 'Premium true-wireless earbuds with adaptive active noise cancellation and a long-lasting battery that keeps your music going all day.',
    keyBenefits: ['Adaptive active noise cancellation', 'Up to 32-hour total playtime', 'Transparency mode for awareness'],
    usage: 'Pair via Bluetooth, choose ANC or transparency mode in the app, and enjoy immersive, distraction-free sound.',
    features: ['Active ANC', '32h Battery', 'Transparency Mode', 'Wireless Charging'],
    inStock: true,
  },
  {
    id: 'modern-wireless-headphones',
    name: 'Modern Wireless Headphones',
    slug: 'modern-wireless-headphones',
    sku: 'RTF-AUD-007',
    price: 120.08,
    image: 'https://novagen.s3.us-east-2.amazonaws.com/vI2q4IFJf81VmvHKWJuEjGRHJbyitaFGg0icOElG.jpg',
    badge: 'Popular',
    categoryId: 'headphones',
    categorySlug: 'headphones',
    description: 'Experience exceptional audio quality with these sleek modern over-ear wireless headphones featuring plush memory-foam cushions for long sessions.',
    keyBenefits: ['Rich, detailed full-range audio', 'Plush memory-foam ear cushions', 'Foldable for easy travel'],
    usage: 'Charge, pair over Bluetooth, and adjust the headband for an all-day comfortable fit.',
    features: ['Over-Ear', 'Bluetooth 5.0', 'Memory Foam', 'Foldable'],
    inStock: true,
  },
  {
    id: 'gaming-headset-rgb',
    name: 'Gaming Headset with RGB Lighting',
    slug: 'gaming-headset-rgb',
    sku: 'RTF-AUD-008',
    price: 52.47,
    image: 'https://novagen.s3.us-east-2.amazonaws.com/IEpGs3LKs2R34Rp8E00x5byOhRH74cpvbz8FUOGM.png',
    badge: 'Gaming',
    categoryId: 'headphones',
    categorySlug: 'headphones',
    description: 'An over-ear gaming headset with 50mm neodymium drivers, customizable RGB lighting on each earcup, a detachable boom mic and memory-foam earpads.',
    keyBenefits: ['Immersive 50mm driver sound', 'Customizable RGB lighting', 'Detachable noise-cancelling boom mic'],
    usage: 'Connect via USB or 3.5mm, position the boom mic, and customize the RGB lighting to match your setup.',
    features: ['50mm Drivers', 'RGB Lighting', 'Detachable Mic', 'Memory Foam'],
    inStock: true,
  },

  // ---------- GAMING GEAR ----------
  {
    id: 'wireless-bluetooth-gaming-mouse',
    name: 'Wireless Bluetooth Gaming Mouse',
    slug: 'wireless-bluetooth-gaming-mouse',
    sku: 'RTF-GMG-009',
    price: 34.98,
    image: 'https://novagen.s3.us-east-2.amazonaws.com/01J0BT9HK63QHKR4TD8E3TDYMT.jpg',
    categoryId: 'gaming',
    categorySlug: 'gaming',
    description: 'Unleash peak gaming performance with this high-performance wireless Bluetooth gaming mouse, tuned for speed, precision and all-day comfort.',
    keyBenefits: ['High-precision optical sensor', 'Lag-free wireless connection', 'Ergonomic, grippy contour'],
    usage: 'Plug in the USB receiver or pair over Bluetooth, adjust DPI on the fly, and game without cables.',
    features: ['Wireless', 'Adjustable DPI', 'Ergonomic', 'Rechargeable'],
    inStock: true,
  },
  {
    id: 'jazz-mechanical-keyboard',
    name: 'Jazz Mechanical Keyboard with Customizable Keys',
    slug: 'jazz-mechanical-keyboard',
    sku: 'RTF-GMG-010',
    price: 52.47,
    image: 'https://novagen.s3.us-east-2.amazonaws.com/01J0BP39GWWY6MQD879RXYW3W4.jpg',
    badge: 'Hot-Swap',
    categoryId: 'gaming',
    categorySlug: 'gaming',
    description: 'Type with satisfying tactile feedback on this hot-swappable mechanical keyboard with customizable keycaps and vibrant per-key backlighting.',
    keyBenefits: ['Hot-swappable mechanical switches', 'Customizable keycaps and lighting', 'Sturdy, premium chassis'],
    usage: 'Plug in via USB-C, swap switches or keycaps to taste, and tune the backlight effects with the function keys.',
    features: ['Hot-Swap', 'RGB Backlight', 'Mechanical', 'USB-C'],
    inStock: true,
  },
  {
    id: 'wireless-gaming-mouse',
    name: 'Lightweight Wireless Gaming Mouse',
    slug: 'wireless-gaming-mouse',
    sku: 'RTF-GMG-011',
    price: 35.96,
    image: 'https://novagen.s3.us-east-2.amazonaws.com/LAhFM1viFVQ71iaudgUW6qXIQXWxNleKFaeLA5Cr.jpg',
    badge: 'Esports',
    categoryId: 'gaming',
    categorySlug: 'gaming',
    description: 'Gain a competitive edge with this lightweight wireless gaming mouse engineered for fast flicks, precise tracking and marathon esports sessions.',
    keyBenefits: ['Ultra-light for fast movement', 'High-DPI esports sensor', 'Low-latency wireless'],
    usage: 'Connect the wireless dongle, set your preferred DPI, and dominate your matches with precise control.',
    features: ['Ultra-Light', 'High DPI', 'Wireless', 'Esports Grade'],
    inStock: true,
  },
  {
    id: 'wireless-gaming-keyboard-macro',
    name: 'Wireless Gaming Keyboard with Macro Keys',
    slug: 'wireless-gaming-keyboard-macro',
    sku: 'RTF-GMG-012',
    price: 120.08,
    image: 'https://novagen.s3.us-east-2.amazonaws.com/2JdgctIeX6qhjbyAkjBJBNPlhQIb9HOyqV1e5qqE.png',
    badge: 'Pro Gaming',
    categoryId: 'gaming',
    categorySlug: 'gaming',
    description: 'A full-size wireless gaming keyboard with hot-swappable mechanical switches, dedicated macro keys and a long-lasting rechargeable battery.',
    keyBenefits: ['Dedicated programmable macro keys', 'Hot-swappable mechanical switches', 'Wireless and wired modes'],
    usage: 'Use it wirelessly or plug in via USB-C, program macros in the software, and customize the RGB lighting.',
    features: ['Macro Keys', 'Hot-Swap', 'Wireless', 'RGB'],
    inStock: true,
  },

  // ---------- TABLETS & E-READERS ----------
  {
    id: 'smart-tablet-with-keyboard',
    name: 'Smart Tablet with Detachable Keyboard',
    slug: 'smart-tablet-with-keyboard',
    sku: 'RTF-TAB-013',
    price: 120.08,
    image: 'https://novagen.s3.us-east-2.amazonaws.com/01HZFKYRP3XW8699HHNZ1Z71S8.jpg',
    badge: '2-in-1',
    categoryId: 'tablets',
    categorySlug: 'tablets',
    description: 'Blend tablet portability with laptop productivity using this 2-in-1 device and its included detachable keyboard for work and play on the go.',
    keyBenefits: ['2-in-1 tablet and laptop experience', 'Included detachable keyboard', 'Vivid touchscreen display'],
    usage: 'Snap on the keyboard for productivity or detach it to use as a touchscreen tablet wherever you are.',
    features: ['2-in-1', 'Detachable Keyboard', 'Touchscreen', 'Portable'],
    inStock: true,
  },
  {
    id: 'advanced-ebook-reader',
    name: 'Advanced e-Book Reader with Digital Pen',
    slug: 'advanced-ebook-reader',
    sku: 'RTF-TAB-014',
    price: 213.32,
    image: 'https://novagen.s3.us-east-2.amazonaws.com/01J0BVSH4BG563GHYWR2GNH39A.jpg',
    badge: 'Bestseller',
    categoryId: 'tablets',
    categorySlug: 'tablets',
    description: 'A cutting-edge e-book reader with a glare-free paper-like display and an included digital pen for reading, note-taking and marking up documents.',
    keyBenefits: ['Glare-free, eye-friendly display', 'Write and annotate with the digital pen', 'Weeks of battery on a single charge'],
    usage: 'Load your books and PDFs, read comfortably in any light, and use the pen to highlight or take handwritten notes.',
    features: ['E-Ink Display', 'Digital Pen', 'Long Battery', 'Glare-Free'],
    inStock: true,
  },
  {
    id: 'classic-black-graphic-drawing-tablet',
    name: 'Classic Black Graphic Drawing Tablet',
    slug: 'classic-black-graphic-drawing-tablet',
    sku: 'RTF-TAB-015',
    price: 213.32,
    image: 'https://novagen.s3.us-east-2.amazonaws.com/CsbEim2iq7bVoNFsjVhBzbUuSGOgKDgHgPPRixEb.png',
    categoryId: 'tablets',
    categorySlug: 'tablets',
    description: 'A versatile graphic drawing tablet designed for beginners and professionals alike, with a responsive pressure-sensitive pen and a large active area.',
    keyBenefits: ['Pressure-sensitive stylus', 'Large, smooth drawing surface', 'Works with major creative software'],
    usage: 'Connect to your computer via USB, install the driver, and start drawing directly into your favorite design apps.',
    features: ['Pressure Pen', 'Large Active Area', 'USB', 'Creator Ready'],
    inStock: true,
  },
  {
    id: 'graphic-tablet-monitor-stylus',
    name: 'Graphic Tablet Monitor with Shortcut Keys & Stylus',
    slug: 'graphic-tablet-monitor-stylus',
    sku: 'RTF-TAB-016',
    price: 239.94,
    image: 'https://novagen.s3.us-east-2.amazonaws.com/zvQUJygDjugg5U1VK6sVHqpeE2Yo5Ou7EqV3eoiM.png',
    badge: 'Artist',
    categoryId: 'tablets',
    categorySlug: 'tablets',
    description: 'A pen-display graphic tablet monitor for aspiring and professional digital artists, letting you draw directly on a vibrant color-accurate screen.',
    keyBenefits: ['Draw directly on the screen', 'Customizable shortcut keys', 'Color-accurate display for creators'],
    usage: 'Connect to your computer, position the display at a comfortable angle, and illustrate right on the glass with the included stylus.',
    features: ['Pen Display', 'Shortcut Keys', 'Color Accurate', 'Stylus Included'],
    inStock: true,
  },

  // ---------- MONITORS & DISPLAYS ----------
  {
    id: '4k-usb-c-webcam',
    name: '4K USB-C Webcam',
    slug: '4k-usb-c-webcam',
    sku: 'RTF-MON-017',
    price: 52.47,
    image: 'https://novagen.s3.us-east-2.amazonaws.com/d2hRtvK6tNwuiU8ZOaYnwET7AUKI6K0tERt4cKpG.png',
    badge: '4K',
    categoryId: 'monitors',
    categorySlug: 'monitors',
    description: 'A premium 4K ultra-HD USB-C webcam with a large sensor and dual-microphone beamforming for sharp, professional video calls and streaming.',
    keyBenefits: ['Crisp 4K ultra-HD video', 'Dual-mic noise reduction', 'Plug-and-play USB-C'],
    usage: 'Clip onto your monitor or laptop, plug in via USB-C, and select it as your camera in any video app.',
    features: ['4K UHD', 'Dual Mic', 'USB-C', 'Auto Focus'],
    inStock: true,
  },
  {
    id: 'mini-hd-projector',
    name: 'Mini HD Projector',
    slug: 'mini-hd-projector',
    sku: 'RTF-MON-018',
    price: 69.96,
    image: 'https://novagen.s3.us-east-2.amazonaws.com/hOYAvOWzOb0pLcgP3NPEA9Ds0MOlJGPLFXeDjXH8.png',
    categoryId: 'monitors',
    categorySlug: 'monitors',
    description: 'A portable mini HD projector with native 1080p support and HDMI/USB inputs that turns any wall into a big-screen movie night in seconds.',
    keyBenefits: ['Big-screen 1080p projection', 'Compact and travel-friendly', 'HDMI, USB and Bluetooth inputs'],
    usage: 'Connect your device via HDMI or stream wirelessly, point at a wall or screen, and adjust focus for a sharp picture.',
    features: ['1080p Support', 'HDMI/USB', 'Bluetooth', 'Portable'],
    inStock: true,
  },
  {
    id: 'pixxel-xf24hd-gaming-monitor',
    name: '24" 165Hz Full HD Gaming Monitor',
    slug: 'pixxel-xf24hd-gaming-monitor',
    sku: 'RTF-MON-019',
    price: 120.08,
    image: 'https://ectechsavvy.com/products/p15-pixxel-xf24hd.png',
    badge: '165Hz',
    categoryId: 'monitors',
    categorySlug: 'monitors',
    description: 'A 24-inch Full HD IPS gaming monitor with a blazing 165Hz refresh rate and 1ms response time for smooth, tear-free competitive gameplay.',
    keyBenefits: ['Fast 165Hz refresh rate', '1ms response time', 'Crisp Full HD IPS panel'],
    usage: 'Connect via HDMI or DisplayPort, enable the high refresh rate in your settings, and enjoy buttery-smooth motion.',
    features: ['165Hz', '1ms', 'IPS Panel', 'Full HD'],
    inStock: true,
  },
  {
    id: 'ultra-wide-curved-monitor',
    name: '34" Ultra-Wide Curved Monitor',
    slug: 'ultra-wide-curved-monitor',
    sku: 'RTF-MON-020',
    price: 213.32,
    image: 'https://novagen.s3.us-east-2.amazonaws.com/YUyi0mcklSRlZjQRPLnURiaAbjsyoZvbZXsD6ceB.png',
    badge: '34"',
    categoryId: 'monitors',
    categorySlug: 'monitors',
    description: 'An immersive 34-inch ultra-wide curved monitor with WQHD resolution and a high refresh rate that wraps your view in extra screen real estate.',
    keyBenefits: ['Expansive ultra-wide WQHD canvas', 'Immersive curved panel', 'High refresh for work and play'],
    usage: 'Mount or stand it on your desk, connect via HDMI or DisplayPort, and enjoy multitasking across one giant screen.',
    features: ['Ultra-Wide', 'WQHD', 'Curved', 'High Refresh'],
    inStock: true,
  },

  // ---------- SMART HOME & ESSENTIALS ----------
  {
    id: 'portable-power-bank',
    name: 'Portable Power Bank 10,000mAh',
    slug: 'portable-power-bank',
    sku: 'RTF-ESS-021',
    price: 8.99,
    image: 'https://novagen.s3.us-east-2.amazonaws.com/V9k6qTVt5hh82slLBMPKlbg1odYukKPcz4XwE9gf.webp',
    badge: 'Deal',
    categoryId: 'smart-home',
    categorySlug: 'smart-home',
    description: 'A high-capacity 10,000mAh portable power bank that keeps your phone, earbuds and gadgets charged through long days and travel.',
    keyBenefits: ['10,000mAh of backup power', 'Fast dual-port charging', 'Slim, pocketable design'],
    usage: 'Charge the power bank fully, then plug in your devices via USB to top them up anywhere.',
    features: ['10,000mAh', 'Dual USB', 'Fast Charge', 'Slim'],
    inStock: true,
  },
  {
    id: 'adjustable-ergonomic-laptop-stand',
    name: 'Adjustable Ergonomic Laptop Stand',
    slug: 'adjustable-ergonomic-laptop-stand',
    sku: 'RTF-ESS-022',
    price: 17.98,
    image: 'https://novagen.s3.us-east-2.amazonaws.com/01J0BXCJECE53NH51VA7GCKEYH.jpg',
    badge: 'Ergo',
    categoryId: 'smart-home',
    categorySlug: 'smart-home',
    description: 'An adjustable ergonomic laptop stand that lifts your screen to eye level, improving posture and airflow during long work sessions.',
    keyBenefits: ['Raises screen to a healthier height', 'Improves laptop cooling and airflow', 'Folds flat for easy travel'],
    usage: 'Unfold the stand, set your preferred height and angle, and place your laptop on the secure rests.',
    features: ['Adjustable', 'Foldable', 'Ventilated', 'Aluminum'],
    inStock: true,
  },
  {
    id: 'portable-ssd-external-drive',
    name: 'Portable SSD External Drive 1TB',
    slug: 'portable-ssd-external-drive',
    sku: 'RTF-ESS-023',
    price: 120.08,
    image: 'https://novagen.s3.us-east-2.amazonaws.com/56t5UAJgakNvmsqc5GEfazTv2b5jEMTZmlsHF9ly.png',
    badge: '1 TB',
    categoryId: 'smart-home',
    categorySlug: 'smart-home',
    description: 'An ultra-compact 1TB portable external SSD with USB 3.2 Gen 2 and fast read speeds for backing up files, photos and 4K video on the move.',
    keyBenefits: ['Fast USB 3.2 transfer speeds', '1TB of pocketable storage', 'Shock-resistant solid-state design'],
    usage: 'Plug into any USB-C or USB-A port, drag and drop your files, and carry your data anywhere.',
    features: ['1TB', 'USB 3.2', 'Shock Resistant', 'Compact'],
    inStock: true,
  },
  {
    id: 'smart-home-hub-controller',
    name: 'Smart Home Hub Controller',
    slug: 'smart-home-hub-controller',
    sku: 'RTF-ESS-024',
    price: 69.96,
    image: 'https://novagen.s3.us-east-2.amazonaws.com/0vJhH8RZWObWFuKGy2QJsD3uPO1OUIIe3u51hjMf.png',
    badge: 'Smart',
    categoryId: 'smart-home',
    categorySlug: 'smart-home',
    description: 'A central smart-home hub supporting Matter, Zigbee, Z-Wave, Thread and Wi-Fi, letting you connect and automate all of your smart devices in one place.',
    keyBenefits: ['Connects Matter, Zigbee, Z-Wave & Thread', 'One app to automate your home', 'Reliable local + cloud control'],
    usage: 'Plug in the hub, connect it to your network in the app, and pair your smart lights, locks and sensors.',
    features: ['Matter', 'Zigbee', 'Z-Wave', 'Wi-Fi'],
    inStock: true,
  },
];

// ============================================
// CATEGORIES
// ============================================
export const categories = [
  {
    id: 'speakers',
    name: 'Speakers & Audio',
    slug: 'speakers',
    description: 'Bluetooth speakers, soundbars and audio systems for room-filling sound',
    image: 'https://novagen.s3.us-east-2.amazonaws.com/2AcnDnCC0TEDlNuC0lIzKzZmiQwN58TqS5c1EG4p.png',
    productCount: 4,
  },
  {
    id: 'headphones',
    name: 'Headphones & Earbuds',
    slug: 'headphones',
    description: 'Wireless headphones, true-wireless earbuds and gaming headsets',
    image: 'https://novagen.s3.us-east-2.amazonaws.com/vI2q4IFJf81VmvHKWJuEjGRHJbyitaFGg0icOElG.jpg',
    productCount: 4,
  },
  {
    id: 'gaming',
    name: 'Gaming Gear',
    slug: 'gaming',
    description: 'Mechanical keyboards, gaming mice and precision esports gear',
    image: 'https://novagen.s3.us-east-2.amazonaws.com/01J0BP39GWWY6MQD879RXYW3W4.jpg',
    productCount: 4,
  },
  {
    id: 'tablets',
    name: 'Tablets & E-Readers',
    slug: 'tablets',
    description: 'Smart tablets, e-readers and pen-display drawing tablets for creators',
    image: 'https://novagen.s3.us-east-2.amazonaws.com/zvQUJygDjugg5U1VK6sVHqpeE2Yo5Ou7EqV3eoiM.png',
    productCount: 4,
  },
  {
    id: 'monitors',
    name: 'Monitors & Displays',
    slug: 'monitors',
    description: 'Gaming monitors, ultra-wide displays, projectors and 4K webcams',
    image: 'https://novagen.s3.us-east-2.amazonaws.com/YUyi0mcklSRlZjQRPLnURiaAbjsyoZvbZXsD6ceB.png',
    productCount: 4,
  },
  {
    id: 'smart-home',
    name: 'Smart Home & Essentials',
    slug: 'smart-home',
    description: 'Smart hubs, power banks, storage and everyday tech accessories',
    image: 'https://novagen.s3.us-east-2.amazonaws.com/0vJhH8RZWObWFuKGy2QJsD3uPO1OUIIe3u51hjMf.png',
    productCount: 4,
  },
];

// ============================================
// FEATURES / BENEFITS / STEPS
// ============================================
export const features = [
  { id: 1, title: 'Latest Technology', description: 'Hand-picked electronics and smart gadgets built around the newest tech' },
  { id: 2, title: 'Free USA Shipping', description: 'Free USPS shipping on every order over $75 within the USA' },
  { id: 3, title: '30-Day Returns', description: 'Changed your mind? Easy, no-hassle 30-day returns' },
  { id: 4, title: 'Expertly Curated', description: 'A carefully curated selection of high-performance devices' },
];

export const performanceBenefits = [
  { id: 1, title: 'Performance', description: 'High-performance gadgets engineered for speed and reliability' },
  { id: 2, title: 'Innovation', description: 'Innovative solutions that keep you ahead of the curve' },
  { id: 3, title: 'Design', description: 'Sleek, user-friendly designs that look great on any desk' },
  { id: 4, title: 'Value', description: 'Competitive pricing on expertly curated tech you can trust' },
];

export const steps = [
  { id: 1, title: 'Discover Tech', description: 'Explore the latest electronics and smart gadgets for every need.' },
  { id: 2, title: 'Build Your Setup', description: 'Pick the audio, gaming and smart-home gear that fits your life.' },
  { id: 3, title: 'Secure Checkout', description: 'Safe, encrypted checkout with your payment data fully protected.' },
  { id: 4, title: 'Power Up', description: 'Unbox fast, plug in and future-proof your everyday tech.' },
];
